/* eslint-disable no-nested-ternary */
import React, { useState, useMemo, useEffect, useRef } from "react";
import clsx from "clsx";
import styled from "styled-components";
// import { Container, Row, Col } from "react-grid-system";
import {
  marginInlineStart,
  borderRadius,
  colors,
  space,
  responsive,
} from "utils/theme";
// import Fields from "components/Fields2";
// import Button from "components/Button";
import { useForm, FormProvider } from "react-hook-form";
import { onSearchByText } from "utils/groupUtils";
import TextFieldComponent from "../TextFieldComponent";
import SelectComponent from "../SelectComponent";
import Button from "../Button";
import {
  getOrientations,
  getSegments,
  getUitTypes,
  getCategories,
} from "../utils";
import { cloneDeep } from "lodash";

const columns = [
  { title: "ردیف", key: "#id", style: { width: 60 } },
  { title: "عنوان", key: "title" },
  { title: "جمع تعداد واحد", key: "totalUnit", style: { width: 90 } },
  { title: "نوع واحد", key: "unitType", style: { width: 100 } },
  { title: "دسته بندی", key: "category", style: { width: 100 } },
  { title: "پیش‌نیاز", key: "prereq", style: { width: 60 } }, //  TODO: Isn't provided in service
  { title: "هم‌نیاز", key: "sidereq", style: { width: 60 } }, //  TODO: Isn't provided in service
];

function CoursesCMP({ className, data = [] }) {
  const initCourses = useMemo(
    () => data?.map((item) => item?.map((v) => v?.coursesList).flat()),
    [data]
  );
  const [dataToShow, setDataToShow] = useState([...data]);
  const orientations = useMemo(
    () => [
      { label: "همه", value: "-1" },
      ...getOrientations(data).map((item) => ({ ...item, label: item.name })),
    ],
    [data]
  );
  const segments = useMemo(
    () => [
      { label: "همه", value: "-1" },
      ...getSegments(data).map((item) => ({ ...item, label: item.name })),
    ],
    [data]
  );
  const unitTypes = useMemo(
    () => [
      { label: "همه", value: "-1" },
      ...getUitTypes(data).map((item) => ({ ...item, label: item.name })),
    ],
    [data]
  );
  const categories = useMemo(
    () => [
      { label: "همه", value: "-1" },
      ...getCategories(data).map((item) => ({ ...item, label: item.name })),
    ],
    [data]
  );

  // Form Init
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const initQueries = {
    courseTitle: "",
    unitCount: "",

    category: "-1",
    orientation: "-1",
    segment: "-1",
    unitType: "-1",
  };
  const resetForm = () => {
    reset(initQueries);
    setDataToShow([...data]);
  };
  useEffect(() => {
    reset(initQueries);
    setDataToShow([...data]);
  }, [data]);

  const onSubmit = async (queries) => {
    let dataToSet = cloneDeep(data);

    // Course Title Search
    if (queries?.courseTitle?.length > 0) {
      const titleSearchResult = await onSearchByText(
        queries.courseTitle,
        initCourses
      );
      dataToSet = dataToSet.map((item) =>
        item.map((v, k) => ({
          ...v,
          coursesList: titleSearchResult[k],
        }))
      );
    }

    // Unit Count Search
    if (`${queries.unitCount ?? ""}`.length > 0) {
      const res = dataToSet?.map((item) =>
        item.map((v) => ({
          ...v,
          coursesList: v.coursesList.filter(
            // eslint-disable-next-line eqeqeq
            (course) => String(course.totalUnit) === String(queries.unitCount)
          ),
        }))
      );
      dataToSet = cloneDeep(res);
    }

    // Orientation Filter
    if (
      queries?.orientation &&
      // eslint-disable-next-line eqeqeq
      queries?.orientation?.value != -1 &&
      `${queries?.orientation?.value ?? ""}`.length > 0
    ) {
      const res = dataToSet.map((item) =>
        item.filter((oriItem) => oriItem?.title === queries?.orientation?.value)
      );
      dataToSet = cloneDeep(res);
    }

    // Segment Filter
    if (
      queries?.segment &&
      // eslint-disable-next-line eqeqeq
      queries?.segment?.value != -1 &&
      `${queries?.segment?.value ?? ""}`.length > 0
    ) {
      const res = dataToSet.map((item) =>
        item.filter(
          (oriItem) =>
            oriItem?.segmentAndSegmentType === queries?.segment?.value
        )
      );
      dataToSet = cloneDeep(res);
    }

    // Unit Type Filter
    if (
      queries?.unitType &&
      // eslint-disable-next-line eqeqeq
      queries?.unitType?.value != -1 &&
      `${queries.unitType?.value ?? ""}`.length > 0
    ) {
      const res = dataToSet.map((item) =>
        item.map((v) => ({
          ...v,
          coursesList: v.coursesList.filter(
            (course) => course.unitType === queries?.unitType?.value
          ),
        }))
      );
      dataToSet = cloneDeep(res);
    }

    // Category Filter
    if (
      queries?.category &&
      // eslint-disable-next-line eqeqeq
      queries?.category?.value != -1 &&
      `${queries.category?.value ?? ""}`.length > 0
    ) {
      const res = dataToSet.map((item) =>
        item.map((v) => ({
          ...v,
          coursesList: v.coursesList.filter(
            (course) =>
              String(course.category) === String(queries?.category?.value)
          ),
        }))
      );
      dataToSet = cloneDeep(res);
    }

    setDataToShow(cloneDeep(dataToSet));
  };
  // Printer
  const componentRef = useRef(null);

  return (
    <div className={className} ref={componentRef}>
      <br />
      <FormProvider control={control} register={register}>
        <form className="__header-form" onSubmit={handleSubmit(onSubmit)}>
          <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-[30px] md:tw-gap-x-10 tw-gap-y-[26px]">
            <div className="tw-col-span-2 md:tw-col-span-3">
              <TextFieldComponent
                name="courseTitle"
                label="عنوان درس"
                placeholder="جستجو در عناوین دروس..."
              />
            </div>
            <div className="tw-col-span-2 md:tw-col-span-1">
              <TextFieldComponent name="unitCount" label="تعداد واحد" />
            </div>
            <div>
              <SelectComponent
                name="orientation"
                label="رشته / گرایش"
                placeholder="همه"
                options={orientations}
              />
            </div>
            <div>
              <SelectComponent
                name="segment"
                label="مقطع"
                placeholder="همه"
                options={segments}
              />
            </div>
            <div>
              <SelectComponent
                name="unitType"
                label="نوع واحد"
                placeholder="همه"
                options={unitTypes}
              />
            </div>
            <div>
              <SelectComponent
                name="category"
                label="دسته بندی"
                placeholder="همه"
                options={categories}
              />
            </div>
            <div className="tw-col-span-2 sm:tw-col-span-1">
              <Button type="button" onClick={resetForm} layout="secondary">
                حذف فیلتر ها
              </Button>
            </div>
            <div className="tw-col-span-2 sm:tw-col-span-1">
              <Button type="submit" layout="primary">
                جستجو
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
      <br />
      {dataToShow?.map((item, i) => {
        return item?.map((oriItem, oriKey) => (
          <React.Fragment key={String(i) + String(oriKey)}>
            <p className={clsx("part-title", oriKey === 0 && "first")}>
              {oriItem?.title ? `${oriItem?.type}: ${oriItem?.title}` : "-"}
              {oriItem.title && oriItem.segmentAndSegmentType ? " - " : ""}
              {oriItem.segmentAndSegmentType
                ? `مقطع: ${oriItem.segmentAndSegmentType}`
                : ""}
            </p>
            <div className="table-container">
              <table className="tw-min-w-[1200px] md:tw-min-w-[unset]">
                <thead>
                  <tr>
                    {columns.map((v) => (
                      <th key={v.title} style={v.style ?? {}}>
                        {v?.title ?? "-"}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {oriItem?.coursesList?.map((v, k) => (
                    <tr key={v.code}>
                      {columns.map((vd, kd) => (
                        <td key={`${vd.key + kd}`}>
                          {vd.key === "#id" ? k + 1 : v?.[vd.key] ?? "-"}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </React.Fragment>
        ));
      })}
      {/* <Printer componentRef={componentRef} /> */}
    </div>
  );
}

const Courses = styled(CoursesCMP)`
  @media print {
    padding: ${space(4)};
    border: 1px solid black;
    margin: ${space(2)};
    width: calc(100% - ${space(4)});
    .hide-on-print {
      display: none;
    }
  }

  .discard-button {
    background: ${colors.primary.lightest};
    color: ${colors.primary.main};
    font-weight: 400;
    border-color: ${colors.primary.lightest};
    ${marginInlineStart(1.5)};
  }

  .part-title {
    @media (min-width: ${responsive.md}) {
      font-size: 13px;
    }
    @media (min-width: ${responsive.xxxl}) {
      font-size: 17.33px;
    }
    background: ${colors.primary.main};
    color: white;
    padding: ${space(2)};
    text-align: center;
    &.first {
      border-top-left-radius: ${borderRadius.normal};
      border-top-right-radius: ${borderRadius.normal};
    }
  }
  .table-container {
    overflow: auto;
  }
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    th {
      font-size: 0.9rem;
      font-weight: 500;
      padding-top: ${space(1.5)};
      padding-bottom: ${space(1.5)};
      border-left: 1px solid ${colors.primary.lighter};
      &:first-child {
        border-right: 1px solid ${colors.primary.lighter};
      }
    }
    td {
      @media (min-width: ${responsive.xxxl}) {
        font-size: 17.33px;
      }
      font-size: 1rem;
      font-weight: 300;
      padding-top: ${space(1)};
      padding-bottom: ${space(1)};
      border-left: 1px solid ${colors.primary.lighter};
      /* border-top: 1px solid ${colors.primary.lighter}; */
      &:first-child {
        border-right: 1px solid ${colors.primary.lighter};
      }
    }
    tr {
      &:nth-child(odd) {
        td {
          background: #edf6ff;
        }
      }
      &:nth-child(even) {
        td {
          background: #ffffff;
        }
      }
      &:last-child {
        td {
          border-bottom: 1px solid ${colors.primary.lighter};
        }
      }
    }
  }
`;

export default Courses;
